
//** MUI Import
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// ** Icons Imports
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'

const CustomYellowCard = () => {
  return (
    <Box sx={{ px: 3, py: 30 }}>
      <Typography variant='h3' color={theme => theme.palette.error.light} textAlign='center'
        sx={{
          fontWeight: 600,
          borderRadius: 1
        }}>
        <WarningAmberRoundedIcon fontSize='inherit' />
      </Typography>
      <Typography variant='h5' color='' textAlign='center'
        sx={{
          fontWeight: 600,
          borderRadius: 1
        }}>
        Tidak ada rekrutmen untuk kategori ini.
      </Typography>
    </Box>
  )
}

export default CustomYellowCard
